import { useQuery } from '@apollo/client';
import { useAuth } from '@contexts/AuthContext';
import { GET_BRANDS_UPERCUT_FILTERED } from '@gql/brand';
import { BrandsFilter } from './useGetBrands';

export const useGetBrandsByCompany = (
    proId: string,
    query: string = '',
    pagination: { offset: number; limit: number },
    filter: BrandsFilter = {},
) => {
    const { user } = useAuth();

    const { data, loading, error, refetch } = useQuery(GET_BRANDS_UPERCUT_FILTERED, {
        notifyOnNetworkStatusChange: true,
        variables: {
            query,
            pagination,
            filter: { pro: proId, ...filter },
        },
        skip: !user || !proId,
    });

    const brandsData = data?.getBrandsUpercut;

    return {
        brands: brandsData?.docs ?? [],
        total: brandsData?.meta?.totalDocs ?? 0,
        loading,
        error,
        refetch,
    };
};
